var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"slim",attrs:{"id":"photo-upload"}},[(_vm.contactTask)?_c('input',{ref:`file_${_vm.contactTask.contact.contactId}`,attrs:{"id":`file_${_vm.contactTask.contact.contactId}`,"type":"file","name":"slim[]"}}):_vm._e(),_c('div',{staticClass:"current-photo",style:(_vm.photoStyle)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }